<div [ngClass]="orientation == 'horizontal' ? 'vm-radio-check-list vm-radio-check-list--horizontal' : 'vm-form'">
  <ng-container *ngIf="
      valuefield != '' && textfield != '';
      then complex_data;
      else non_complex_data
    ">
  </ng-container>
  <ng-template #non_complex_data>
    <div class="form-check vm-radio" *ngFor="let item of data; let i = index; let f = first; let l = last" [ngClass]="{
        'vm-help-align':
          (orientation == 'horizontal' && l) ||
          (orientation != 'horizontal' && f)
      }">
      <div class="custom-control custom-radio">
        <input class="form-check-input" (focus)="touched()" type="radio" name="rbl_{{ name }}_{{ i }}"
               id="rbl_{{ name }}_{{ i }}" value="{{ item }}" [disabled]="isDisabled" (change)="change($event)"
               [(ngModel)]="selectedvalue" />
        <label class="form-check-label" for="rbl_{{ name }}_{{ i }}">
          {{ item }}
        </label>
      </div>
      <small *ngIf="orientation != 'horizontal' && f && hint != ''" class="vm-hint-inline text-muted">{{ hint }}</small>
      <small *ngIf="orientation == 'horizontal' && l && hint != ''" class="vm-hint-inline text-muted">{{ hint }}</small>
      <div *ngIf="orientation == 'horizontal' && l && help != ''" class="vm-help-icon ml-3" pTooltip="{{ help }}"></div>
      <div *ngIf="orientation != 'horizontal' && f && help != ''" class="vm-help-icon ml-3" pTooltip="{{ help }}"></div>

    </div>
  </ng-template>
  <ng-template #complex_data>
    <div class="form-check vm-radio" *ngFor="let item of data; let i = index; let f = first; let l = last" [ngClass]="{
        'vm-help-align':
          (orientation == 'horizontal' && l) ||
          (orientation != 'horizontal' && f)
      }">
      <div class="custom-control custom-radio">
        <input class="form-check-input" (focus)="touched()" type="radio" name="rbl_{{ name }}_{{ i }}"
               id="rbl_{{ name }}_{{ i }}" [value]="item[valuefield]" [disabled]="isDisabled" (change)="change($event)"
               [(ngModel)]="selectedvalue" />
        <label class="form-check-label" for="rbl_{{ name }}_{{ i }}">
          {{ item[textfield] }}
        </label>
      </div>
      <small *ngIf="orientation != 'horizontal' && f && hint != ''" class="vm-hint-inline text-muted">{{ hint }}</small>
      <small *ngIf="orientation == 'horizontal' && l && hint != ''" class="vm-hint-inline text-muted">{{ hint }}</small>
      <div *ngIf="orientation == 'horizontal' && l && help != ''" class="vm-help-icon ml-3" pTooltip="{{ help }}">
        <span class="material-symbols-outlined vm-icon">help</span>
      </div>
      <div *ngIf="orientation != 'horizontal' && f && help != ''" class="vm-help-icon ml-3" pTooltip="{{ help }}">
        <span class="material-symbols-outlined vm-icon">help</span>
      </div>
    </div>
  </ng-template>
</div>
